import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GalleryItem } from './pages/types/GalleryItem';
import { DUProduct } from './products/types/DUProduct';

const GalleryProductCard = (props: any) => {
    const [selected, setSelected] = useState<boolean>(false);
    const product: DUProduct = props.product;

    useEffect(() => {
        const selectedItems = props.selectedItems ? props.selectedItems.map((i: GalleryItem) => ({ ...i })) : [];
        const matched = selectedItems.filter((i: GalleryItem) => i?.product?.code === product.code);
        setSelected(matched[0]?.selected);
    }, [props.selectedItems, product]);
    const handleSelected = () => {
        const newState = !selected;
        if (props.handleSelected) {
            const galleryItem: GalleryItem = { product, image: product.image, selected: newState, label: product.code, description: product.description, type: 'product', startDate: null, endDate: null }
            props.handleSelected(galleryItem);
        }
        setSelected(newState);
    }
    const getDisplayMeta = () => {
        return (<>
            <small style={{ display: "block", textAlign: "center" }}>{product.code} - {product.name}</small>
        </>)
    }

    return <div key={product.code} onClick={handleSelected} className="me-2 mb-2" style={{ maxWidth: "144px" }}>
        <div className="d-flex align-items-center" style={{ maxWidth: "100%", height: "144px", display: "inline-block", overflow: "hidden", position: "relative", cursor: "pointer" }}>
            {product?.image?.thumbnail && <img style={{ maxHeight: '144px', maxWidth: '100%' }} src={product?.image?.thumbnail} alt="" />}
            {selected && <div className="p-2" style={{ position: "absolute", width: "144px", height: "144px", backgroundColor: "rgba(0,0,0,.05)", zIndex: 1, top: 0, left: 0 }}><FontAwesomeIcon className="text-primary" icon="check-circle" size="lg" /></div>}
        </div>
        {getDisplayMeta()}
    </div>;
};

export default GalleryProductCard;
